import { render, staticRenderFns } from "./ChartMixed.vue?vue&type=template&id=2b2f837e&scoped=true&"
import script from "./ChartMixed.vue?vue&type=script&lang=js&"
export * from "./ChartMixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2f837e",
  null
  
)

export default component.exports